"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const text_1 = require("../text");
exports.Separator = (0, styled_components_1.default)(text_1.Text) `
  margin: 0 0.4235em;
`;
